export default {"src":"/_next/static/media/Apple_store.572d34bc.svg","height":57,"width":185,"blurWidth":0,"blurHeight":0};